import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Modal } from 'react-bootstrap';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CustomInput from '../../../../components/common/Input/input';
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb';
import './editar-imprensa-oficial.scss'
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Flex,
  Heading,
  Box,
  Button,
  FormLabel,
  FormControl,
  Select,
  Stack,
  Checkbox,
  Spinner,
  Alert,
  AlertIcon,
  AlertDescription,
  AlertTitle,
  Wrap,
  TagCloseButton,
  Tag,
  WrapItem,
  TagLabel
} from '@chakra-ui/react';
import { FileWithPath } from 'react-dropzone';
import * as api from '../../../../api/imprensaOficial';
import CustomTextArea from '../../../../components/common/Textarea/textArea';
import Swal from 'sweetalert2';
import { listarCategoriasAtivas } from '../../../../api/categoria';
import { obterUsuario } from '../../../../api/usuario';
import { ImagePdfDropzone } from '../../../../components/common/imagePdfDropzone/imagePdfDropzone';
import { PdfViewerIframe } from '../../../../components/common/PdfViewer';
import { FaPlus } from 'react-icons/fa';
import { MdDownload } from 'react-icons/md';
import { PublicacaoParams } from '../../../../interfaces/publicacao.interface';
import { deletarSecretariaAssociada, listarSecretariasAtivas } from '../../../../api/secretarias';

const EditarImprensaOficial: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const today = new Date().toISOString().split('T')[0];

  const [formValues, setFormValues] = useState<{
    titulo: { value: string; error: boolean };
    data: { value: typeof today; error: boolean };
    imagem: { value: string; error: boolean };
    creditoAutorImprensaOficial: { value: string; error: boolean };
    descricaoImagem: { value: string; error: boolean };
    seqCategoria: { value: any; error: boolean };
    paginaId: { value: any[]; error: boolean };
    secretariaId: {value: any[]; error: boolean };

  }>({
    titulo: { value: '', error: false },
    data: { value: today, error: false },
    imagem: { value: '', error: false },
    creditoAutorImprensaOficial: { value: '', error: false },

    descricaoImagem: { value: '', error: false },
    seqCategoria: { value: '', error: false },
    paginaId: { value: [], error: false },
    secretariaId: {value: [], error: false },

  });

  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [paginas, setPaginas] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const [seqUsuario, setSeqUsuario] = useState<any[]>([]);
  const [removedPages, setRemovedPages] = useState<number[]>([]);
  const [categorias, setCategorias] = useState<any[]>([]);
  const [secretarias, setSecretarias] = useState<any[]>([]);
  const [secretariaSelecionada, setSecretariaSelecionada] = useState<number[]>([]);
  const [secretariasRemovidas, setSecretariasRemovidas] = useState<number[]>([]);
  const [arquivo, setArquivo] = useState<any>();
  const [arquivoSelecionado, setArquivoSelecionado] = useState<File | null>(null);
  const [imagePreview, setImagePreview] = useState<string>("");
  const [nomeCdn, setNomeCdn] = useState<any>(null);
  const [temImagem, setTemImagem] = useState<boolean>(false)
  const [isLoadingButton, setLoadingButton] = useState<boolean>(false);
  const [isDesativoButton, setDesativoButton] = useState<boolean>(false);
  const [isAtivo, setIsAtivo] = useState<number>(1);
  const [getCodSituacaoPubli, setgetCodSituacaoPubli] = useState<number>(1);
  const [getObjPendencia, setgetObjPendencia] = useState<any>();

  const [motivosReprovacao, setMotivosReprovacao] = useState('');

  const fetchImprensaOficialData = async () => {
    setIsLoading(true);
    try {
      const ImprensaOficialData = await api.obterImprensaOficial(Number(id));
      const {
        nomePublicacao,
        datPublicacao,
        datDespublicar,
        dscCreditoImagem,
        dscCreditoNoticia,
        dscDescricaoImagem,
        seqCategoria,
        conteudoSecretariaDTO,
        conteudoPaginaDTO,
        binPublicacao,
        urlBin,
        dscResumo,
        dscPublicacao,
        pendencia,
        numRegistro,
        codSituacaoPubli,
        dscCitacaoUsuario
      } = ImprensaOficialData;
      
      const selecionadas = (conteudoSecretariaDTO ?? []).map((i: any) => Number(i.codSecretaria));

      setFormValues({
        titulo: { value: nomePublicacao, error: false },
        data: { value: datPublicacao || today, error: false },
        imagem: { value: binPublicacao || '', error: false },
        descricaoImagem: { value: dscDescricaoImagem || '', error: false },
        seqCategoria: { value: seqCategoria || '', error: false },
        paginaId: { value: conteudoPaginaDTO.map((item: any) => item.seqPagina.toString()), error: false },
        secretariaId: { value: selecionadas, error: false },
        creditoAutorImprensaOficial: { value: dscCreditoNoticia || '', error: false },
      });
      
      setSecretariaSelecionada(selecionadas);

      if (ImprensaOficialData.numRegistro == 0) {
        setIsAtivo(0)
      }

      if (ImprensaOficialData.codSituacaoPubli) {
        setgetCodSituacaoPubli(ImprensaOficialData.codSituacaoPubli)
      }
      if (ImprensaOficialData.pendencia) {
        setgetObjPendencia(ImprensaOficialData.pendencia)
      }

      if (ImprensaOficialData.imagem) {
        setImagePreview(ImprensaOficialData.imagem);
      }

      if (pendencia && pendencia.dscObs) {
        setMotivosReprovacao(pendencia.dscObs);
      }


      if (binPublicacao && binPublicacao.trim() !== "") {
        setTemImagem(true);

        setFormValues((prev) => ({
          ...prev,
          imagem: { value: binPublicacao, error: false }
        }));

        setImagePreview(atualizarPreview(binPublicacao));
        const delimiter = "%2F";
        const index = binPublicacao.lastIndexOf(delimiter);
        const finalFileName =
          index !== -1 ? binPublicacao.substring(index + delimiter.length) : binPublicacao;
        setNomeCdn(finalFileName);
      } else {
        setTemImagem(false);
      }
    } catch (error) {
      console.error("Erro ao buscar dados da imprensa oficial:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchPaginas = async () => {
    try {
      const data = await api.paginasAtivas();
      setPaginas(data);
    } catch (error) {
      console.error('Erro ao buscar páginas ativas:', error);
    }
  };

  useEffect(() => {
    const storedUsuario = localStorage.getItem('dadosUsuario');
    if (storedUsuario) {
      try {
        const usuario = JSON.parse(storedUsuario);
        setSeqUsuario(usuario.seqUsuario);
        
        const fetchObterUsuario = async () => {
          try {
           const [data, ativas] = await Promise.all([
             obterUsuario(Number(usuario.seqUsuario)),
             listarSecretariasAtivas()
           ]);
           setSecretarias(
            data.usuarioSecretariaDTO?.length ? data.usuarioSecretariaDTO : ativas
          );
          } catch (error) {
            console.error("Erro ao obter usuario:", error);
          }
        };
  
        fetchObterUsuario();
  
      } catch (error) {
        console.error("Erro ao recuperar os dados do usuário:", error);
      }
    }

    const fetchCategorias = async () => {
      try {
        const data = await listarCategoriasAtivas();
        setCategorias(data);
      } catch (error) {
        console.error('Erro ao buscar categorias ativas:', error);
      }
    };

    fetchCategorias();
    fetchImprensaOficialData();
    fetchPaginas();
  }, []);

  const handleDeletePages = async () => {
    try {
      for (const seqPagina of removedPages) {
        await api.deletarRelacionamentoPagina(Number(id), seqPagina);
      }

      setRemovedPages([]);
    } catch (error) {
      console.error('Erro ao remover páginas:', error);
    }
  };

  const handleDeleteSecretarias = async () => {
    try {
      for (const codSecretaria of secretariasRemovidas) {
        await deletarSecretariaAssociada(codSecretaria, Number(id));
      }

      setSecretariasRemovidas([]);
    } catch (error) {
      console.error('Erro ao remover páginas:', error);
    }
  };

  const handleFieldChange = (field: keyof typeof formValues, value: any) => {
    setFormValues({ ...formValues, [field]: { value, error: false } });
  };

  const handleCheckboxSecretaria = (codSecretaria: number, checked: boolean) => {
    setSecretariaSelecionada(prev => {
      const next = checked
        ? Array.from(new Set([...prev, codSecretaria]))
        : prev.filter(id => id !== codSecretaria);
      return next;
    });

    setSecretariasRemovidas(prev =>
      checked
        ? prev.filter(id => id !== codSecretaria)
        : Array.from(new Set([...prev, codSecretaria]))
    );

    setFormValues((prev: any) => {
      const current: number[] = Array.isArray(prev?.secretariaId?.value) ? prev.secretariaId.value : [];
      const next = checked
        ? Array.from(new Set([...current, codSecretaria]))
        : current.filter(id => id !== codSecretaria);

      return {
        ...prev,
        secretariaId: { ...prev.secretariaId, value: next, error: prev?.secretariaId?.error ?? false },
      };
    });
  };

  const handleCheckboxChange = (seqPagina: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      setRemovedPages(prev => prev.filter(id => id !== seqPagina));
    } else {
      setRemovedPages(prev => [...prev, seqPagina]);
    }

    setFormValues((prevValues: any) => {
      const updatedPaginaIdValue = isChecked
        ? [...prevValues.paginaId.value, seqPagina.toString()]
        : prevValues.paginaId.value.filter((id: string) => id !== seqPagina.toString());

      return {
        ...prevValues,
        paginaId: { value: updatedPaginaIdValue },
      };
    });
  };



  const handleDownloadPdf = () => {
    try {
      const urlObj = new URL(imagePreview);
      const pathname = urlObj.pathname;
      const filename = pathname.substring(pathname.lastIndexOf('/') + 1) || 'imprensa-oficial.pdf';
      
      // Método simples que funciona melhor com CDNs e CORS
      const link = document.createElement('a');
      link.href = imagePreview;
      link.download = filename || 'download';
      link.setAttribute('target', '_self');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Erro ao fazer download:', error);
      Swal.fire({
        icon: 'error',
        title: 'Erro ao fazer download',
        text: 'Não foi possível fazer o download do arquivo. Tente novamente.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      });
    }
  };

  const atualizarPreview = (url: string): string => {
    if (url.startsWith("data:")) {
      return url;
    }
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}t=${new Date().getTime()}`;
  };

  const handleImageSelected = async (selecionado: FileWithPath | null) => {
    if (selecionado) {
      const isPdf = selecionado.type === "application/pdf";

      setArquivo(selecionado);
      setArquivoSelecionado(selecionado);

      // Para PDFs, não preencher imagePreview para que o componente mostre o ícone de PDF
      if (isPdf) {
        setImagePreview("");
      } else {
        // Para imagens, converter para base64
        const reader = new FileReader();
        reader.onload = () => {
          if (typeof reader.result === "string") {
            const novaUrl = atualizarPreview(reader.result);
            setImagePreview(novaUrl);
            setFormValues((prev) => ({
              ...prev,
              imagem: { value: novaUrl, error: false },
            }));
          }
        };
        reader.readAsDataURL(selecionado);
      }
    } else {
      setArquivo(null);
      setArquivoSelecionado(null);
      setImagePreview("");
      console.warn("Nenhum arquivo selecionado.");
    }
  };



  const isFormValid = () => {
    const { titulo, data, seqCategoria, paginaId } = formValues;

    const isValid = (
      titulo.value &&
      data.value &&
      seqCategoria.value &&
      (paginaId.value.length > 0)
    );
    return isValid;
  };
  
  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoadingButton(true);

    await handleDeletePages();
    await handleDeleteSecretarias();

    const { creditoAutorImprensaOficial, seqCategoria, paginaId, secretariaId, data, imagem, descricaoImagem } = formValues;

    if (!formValues.seqCategoria.value || !formValues.paginaId.value || formValues.paginaId.value.length === 0) {
      setErrorMessage('Preencha todos os campos obrigatórios.');
      setLoadingButton(false);
      setIsErrorModalOpen(true);
      return;
    }

    if(getCodSituacaoPubli == 6) {
      getObjPendencia['codPendencia'] = 1;
    }

    let codSituacao = 1;

    if (data.value) {
      const dataDaPublicacao = data.value;
      const diaDeHoje = new Date().toISOString().split("T")[0];

      if (getObjPendencia) {
        codSituacao = 5;
      } else if (dataDaPublicacao > diaDeHoje) {
        codSituacao = 1;
      } else if (dataDaPublicacao === diaDeHoje) {
        codSituacao = 2;
      }  
    } else {
      codSituacao = 2;
    }

    const params: PublicacaoParams = {
      seqConteudo: Number(id),
      codTipoPublicacao: 5,
      codSituacaoPubli: codSituacao,
      numRegistro: isAtivo,
      nomePublicacao: formValues.titulo.value || null,
      datPublicacao: formValues.data.value ? formValues.data.value : null,
      datDespublicar: null,
      seqUsuario: seqUsuario,
      binPublicacao: imagem.value || '',
      dscResumo: null,
      urlBin: null,
      dscPublicacao: null,
      dscCreditoImagem: null,
      dscCreditoNoticia: creditoAutorImprensaOficial.value || null,
      dscDescricaoImagem: descricaoImagem.value || null,
      seqCategoria: Number(seqCategoria.value) || null,
      dscCitacaoUsuario: null,
      conteudoPaginaDTO: paginaId.value.map((id: any) => {
        return {
          seqPagina: Number(id),
          numOrdem: 0,
          datFim: null,
        };
      }),
      dscTags: null,
      pendencia: getObjPendencia || null,
      numAprovacao: 0,
      numAprovado: 0,
      datInicioEvento: null,
      datFimEvento: null,
      contasRedeSocial: undefined,
      dscHoraInicioEvento: null,
      dscHoraFimEvento: null,
      dscEnderecoEvento: null,
      conteudoSecretariaDTO: secretariaId.value.map((id: number) => ({
        codSecretaria: id,
      })),
    };

    try {
      if (arquivoSelecionado && temImagem) {
        const formData = new FormData();
        const nomePasta = 'publicacoes';
        const nomeArquivo = nomeCdn || 'imprensa-oficial';

        formData.append('file', arquivoSelecionado);
        formData.append('fileName', nomeArquivo);
        formData.append('folderName', nomePasta);

        const cdnData = await api.editarImprensaOficialNoCdn(formData);
        let cdnUrl = "";

        if (typeof cdnData === "string") {
          const regex = /(https?:\/\/[^\s]+)/g;
          const match = cdnData.match(regex);
          if (match && match[0]) {
            cdnUrl = match[0];
          } else {
            throw new Error("URL não encontrada na resposta do CDN.");
          }
        } else if (cdnData && cdnData.url) {
          cdnUrl = cdnData.url;
        } else {
          throw new Error("Resposta do CDN inesperada.");
        }

        params.binPublicacao = cdnUrl;
      }

      if (arquivoSelecionado && !temImagem) {
        const formData = new FormData();

        const fileExtension = arquivoSelecionado.name.split('.').pop();
        let fileNameToSend = 'imprensa-oficial';

        if (
          fileExtension &&
          !fileNameToSend.toLowerCase().endsWith(`.${fileExtension.toLowerCase()}`)
        ) {
          fileNameToSend = `${fileNameToSend}.${fileExtension}`;
        }

        const nomePasta = 'publicacoes';
        const nomeArquivo = nomeCdn || 'imprensa-oficial';

        formData.append('file', arquivoSelecionado);
        formData.append('fileName', nomeArquivo);
        formData.append('folderName', nomePasta);

        const cdnData = await api.inserirImprensaOficialNoCdn(formData);
        let cdnUrl = "";

        if (typeof cdnData === "string") {
          const regex = /(https?:\/\/[^\s]+)/g;
          const match = cdnData.match(regex);
          if (match && match[0]) {
            cdnUrl = match[0];
          } else {
            throw new Error("URL não encontrada na resposta do CDN.");
          }
        } else if (cdnData && cdnData.url) {
          cdnUrl = cdnData.url;
        } else {
          throw new Error("Resposta do CDN inesperada.");
        }

        params.binPublicacao = cdnUrl;
      }

      await api.editarPublicacao(id, params);
      setLoadingButton(false);

      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Imprensa oficial editada com sucesso.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate(-1)
      });
    } catch (error) {
      setLoadingButton(false);
      console.error('Erro ao editar imprensa oficial:', error);
      Swal.fire({
        icon: 'error',
        title: 'Ocorreu um erro!',
        text: 'Erro ao editar imprensa oficial. Tente novamente mais tarde.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/publicacao/imprensa-oficial');
      });
    }
  };

  const inativarPublicacao = async () => {
    if(getCodSituacaoPubli == 6) {
      getObjPendencia['codPendencia'] = 3;
    }

    Swal.fire({
      title: 'Tem certeza?',
      text: "Certeza que deseja inativar imediatamente a Publicação?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#1789FC',
      cancelButtonColor: '#EDF2F7',
      confirmButtonText: 'Sim, inativar',
      cancelButtonText: 'Cancelar'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const params = {
          pendencia: getObjPendencia || null,
          seqUsuario: seqUsuario,
          numRegistro: 0,
          codSituacaoPubli: 3
        };

        try {
          setDesativoButton(true);
          await api.editarPublicacao(id, params);
          setDesativoButton(false);
          Swal.fire({
            icon: 'success',
            title: 'Sucesso!',
            text: 'Imprensa oficial inativada com sucesso.',
            confirmButtonColor: '#1789FC',
            confirmButtonText: 'OK',
          }).then(() => {
            navigate(-1)     
          });
        } catch (error) {
          setDesativoButton(false);
          console.error('Erro ao inativar imprensa oficial:', error);
          Swal.fire({
            icon: 'error',
            title: 'Ocorreu um erro!',
            text: 'Erro ao inativar imprensa oficial. Tente novamente mais tarde.',
            confirmButtonColor: '#1789FC',
            confirmButtonText: 'OK',
          }).then(() => {
            navigate(-1)
          });
        }
      }
    });
  };

  const mostrarMotivoReprovacao = () => {
    const texto = motivosReprovacao || 'Motivos não informados.';
    const isTextoLongo = texto.length > 150;
  
    Swal.fire({
      title: 'Motivos da Reprovação',
      width: isTextoLongo ? '50%' : undefined,
      html: `<div style="max-height: 250px; overflow-y: auto;">
              <p>${texto}</p>
            </div>`,
      icon: 'warning',
      confirmButtonColor: '#1789FC',
      confirmButtonText: 'Entendi'
    });
  };  
  
  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      < SettingsBreadcrumb />
      <Heading mt="30px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Editar Imprensa Oficial
      </Heading>
      {isAtivo == 0 && (
        <Flex justifyContent="end">
          <Alert status="error" mt="35px" borderRadius="md">
            <AlertIcon />
            <Box flex="1">
              <AlertTitle fontSize="lg" mb={1}>Publicação Inativada</AlertTitle>
              <AlertDescription display="block">
                Esta imprensa oficial foi permanentemente inativada e não poderá ser reativada.
              </AlertDescription>
            </Box>
          </Alert>
        </Flex>
      )}
      {getCodSituacaoPubli === 6 && (
        <Flex justifyContent="end">
          <Alert status="warning" mt="35px" borderRadius="md">
            <AlertIcon />
            <Box flex="1">
              <AlertTitle fontSize="lg" mb={1}>Publicação Reprovada</AlertTitle>
              <AlertDescription display="block">
                Após revisão, sua publicação não obteve aprovação.{' '}
                <Button variant="link" colorScheme="blue" onClick={mostrarMotivoReprovacao}>
                  Clique aqui para ver os motivos.
                </Button>
              </AlertDescription>
            </Box>
          </Alert>
        </Flex>
      )}
      {isLoading ? (
        <Flex
          justify="center"
          align="center"
          direction="column"
          w="70%"
          h="90%"
          position='fixed'
        >
          <Spinner size="xl" color="blue.500" />
        </Flex>
      ) : (

        <Box m="40px 0" w="100%">
          <form onSubmit={handleFormSubmit}>
            <div className="row">
              <div className="col-md-6 mb-4">
                <FormControl isRequired isInvalid={formValues.seqCategoria.error}>
                  <FormLabel mb="8px">Categoria da Imprensa Oficial</FormLabel>
                  <Select
                    placeholder='Selecione uma Categoria'
                    borderColor="gray.300"
                    _hover={{ borderColor: 'blue.500' }}
                    value={formValues.seqCategoria.value}
                    onChange={(e) => handleFieldChange('seqCategoria', e.target.value)}
                  >
                    {categorias.length > 0 ? (
                      categorias.map(categoria => (
                        <option key={categoria.seqCategoria} value={categoria.seqCategoria}>
                          {categoria.dscCategoria}
                        </option>
                      ))
                    ) : (
                      <option disabled>Sem categorias disponíveis</option>
                    )}
                  </Select>
                </FormControl>
              </div>

              <div className="col-md-6 mb-4">
                <FormControl isRequired isInvalid={formValues.titulo.error}>
                  <FormLabel mb="8px">Número da Publicação</FormLabel>
                  <CustomInput
                    placeholder="Digite o número da publicação"
                    value={formValues.titulo.value}
                    onChange={(e: any) => handleFieldChange('titulo', e.target.value)}
                  />
                </FormControl>
              </div>

              <div className="col-md-3 mb-4">
                <FormControl isRequired>
                  <FormLabel mb="8px">Data para Publicação</FormLabel>
                  <CustomInput
                    id="official-media-publication-date"
                    type="date"
                    value={formValues.data.value}
                    onChange={(e) => handleFieldChange('data', e.target.value)}
                  />
                </FormControl>
              </div>


            </div>
            <div className="row mb-3">
              <div className="col-md-6 mb-4">
                <FormControl>
                  <FormLabel mb="8px">Arquivo do Diário Oficial</FormLabel>
                  <ImagePdfDropzone
                    base64={imagePreview}
                    onFileSelected={handleImageSelected}
                    uploadMessage="Arraste uma imagem ou PDF aqui ou clique para selecionar."
                    height={300}
                  />
                  <input
                    id="image-upload"
                    type="file"
                    style={{ display: 'none' }}
                    accept="image/jpeg, image/png"
                    onChange={(e) => handleImageSelected(e.target.files ? e.target.files[0] : null)}
                  />
                  {imagePreview && (
                    <FormControl isRequired className="mt-3">
                      <Flex gap="12px" alignItems="flex-start" mb="24px">
                        <Box minWidth="200px">
                          <PdfViewerIframe 
                            pdfUrl={imagePreview} 
                            buttonLabel="Visualizar PDF"
                            modalTitle="Visualização da Imprensa Oficial"
                          />
                        </Box>
                        <Button
                          leftIcon={<MdDownload />}
                          colorScheme="blue"
                          variant="outline"
                          size="sm"
                          mb="16px"
                          onClick={handleDownloadPdf}
                          whiteSpace="nowrap"
                        >
                          Download
                        </Button>
                      </Flex>
                    </FormControl>
                  )}

                </FormControl>
                <input
                  id="image-upload"
                  type="file"
                  style={{ display: 'none' }}
                  accept="image/jpeg, image/png"
                  onChange={(e) => handleImageSelected(e.target.files ? e.target.files[0] : null)}
                />
                <FormControl mt={'24px'}>
                  <Flex justify="space-between" align="center" mb="8px">
                    <FormLabel mb="8px">
                      Escolha em quais páginas a imprensa oficial deve aparecer <span style={{ color: 'red' }}>*</span>
                    </FormLabel>
                  </Flex>
                  <div className="sidebar-checkbox-pagina">
                    <Stack spacing={5}>
                      {paginas.length > 0 ? (
                        paginas.map((pagina: any) => (
                          <Flex key={pagina.seqPagina} align="center" justify="space-between" direction={{ base: 'column', md: 'row' }}>
                            <Checkbox
                              className="checkPaginasImprensaOficial"
                              isChecked={formValues.paginaId.value.includes(pagina.seqPagina.toString())}
                              onChange={(e) => handleCheckboxChange(pagina.seqPagina, e)}
                            >
                              {pagina.nomPagina}
                            </Checkbox>
                          </Flex>
                        ))
                      ) : (
                        <p>Não há páginas disponíveis.</p>
                      )}
                    </Stack>
                  </div>
                </FormControl>
              </div>
              <div className="col-md-6 mb-4">

                <div className="row mt-4">
                  <div className="col-md-6 mb-4">
                  </div>
                </div>
              </div>
            </div>

            <Flex justifyContent="end" gap={2}>
              <Button
                onClick={inativarPublicacao}
                isDisabled={isAtivo === 0}
                isLoading={isDesativoButton}
                loadingText="Inativando..."
              >
                Inativar Publicação
              </Button>
              <Button
                type="submit"
                color="#FFF"
                bgColor="#1665D8"
                _hover={{ opacity: 0.8 }}
                isDisabled={!isFormValid()}
                isLoading={isLoadingButton}
                loadingText="Editando..."
              >
                Editar Imprensa Oficial
              </Button>
            </Flex>
          </form>
        </Box>
      )}

      <Modal show={isErrorModalOpen} onHide={() => setIsErrorModalOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Atenção!</Modal.Title>
        </Modal.Header>
        <Modal.Body>{errorMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setIsErrorModalOpen(false)}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </Flex>
  );
};

export default EditarImprensaOficial;
